import { createContext, useContext } from 'react';

const StudentChatContext = createContext(null);

export function StudentChatProvider({
  children,
  messages,
  unreadCount,
  historyCount,
  onSend,
  onRead,
  toast,
  onDismissToast,
}) {
  return (
    <StudentChatContext.Provider value={{ messages, unreadCount, historyCount, onSend, onRead, toast, onDismissToast }}>
      {children}
    </StudentChatContext.Provider>
  );
}

export function useStudentChat() {
  return useContext(StudentChatContext);
}
